import { render, staticRenderFns } from "./EventAuthHistory.vue?vue&type=template&id=8f50c66c&lang=pug"
import script from "./EventAuthHistory.vue?vue&type=script&lang=js"
export * from "./EventAuthHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports